class Controller {
  constructor(Events, $interval, PureCloud, StopWatch) {
    this.$interval = $interval;
    this.Events = Events;
    this.watch = StopWatch;
    // PureCloud Config
    this.pureCloudSDK = PureCloud;

    this.stopWatchEvent = this.Events.stopWatchEvent("stopWatch");
    this.resumeWatchEvent = this.Events.resumeWatchEvent("resumeWatch");
  }

  $onInit() {
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.Events.on(this.startWatchEvent, this.watch.start);
    this.Events.on(this.stopWatchEvent, this.watch.stop);
    this.Events.on(this.clearWatchEvent, this.watch.clear);
    this.Events.on(this.resumeWatchEvent, this.watch.resume);
  }

  onMuteCall(mute) {
    try {
      this.pureCloudSDK.mute(
        this.pureCloudSDK.getCallId(),
        this.pureCloudSDK.getParticipants()[0].id,
        mute
      );
    } catch (err) {
      this.Events.emit(this.errorNotificationEvent, {
        message: "Error, No call placed for this participant",
      });
    }
  }

  onHoldCall(held) {
    try {
      this.pureCloudSDK.hold(
        this.pureCloudSDK.getCallId(),
        this.pureCloudSDK.getParticipants()[0].id,
        held
      );
    } catch (err) {
      this.Events.emit(this.errorNotificationEvent, {
        message: "Error, No call placed for this participant",
      });
    }
  }

  onDisconnectCall() {
    try {
      this.pureCloudSDK.disconnect(
        this.pureCloudSDK.getCallId(),
        this.pureCloudSDK.getParticipants()[0].id
      );
      this.watch.clear();
    } catch (err) {
      this.Events.emit(this.errorNotificationEvent, {
        message: "Error in disconnecting this call",
      });
    }
  }

  mute() {
    this.isMute = true;
    this.onMuteCall(!this.isMute);
  }

  unmute() {
    this.isMute = false;
    this.onMuteCall(!this.isMute);
  }

  hold() {
    this.watch.stop();
    this.isHold = true;
    this.onHoldCall(this.isHold);
  }

  unhold() {
    this.watch.resume();
    this.isHold = false;
    this.onHoldCall(this.isHold);
  }

  disconnect() {
    this.onDisconnectCall();
    this.Events.emit(this.endCallEvent);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/call/call.controller.js